<template>
    <div style="position: relative">
        <v-overlay :value="loading" color="white" absolute style="top: -5px">
            <v-progress-circular
                color="var(--v-primary-base)"
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
        <title-and-edit currentViewTitle="Profil" :onlyToggle="false" :hasEdited="!loading && hasChanged && validated" @toggleEdit="toggleEdit" @confirmAction="updateProfile" @changePassword="showOTCdialog = true; currentChangePasswordForm = 'reset-password'" :edit="edit" :layout="layout" :isUserEdit="true"/>
        <div class="pt-5">
            <v-row justify="space-between">
                <v-col cols="12" sm="6" md="6" lg="6">
                    <div class="py-2">
                        <div class="font-weight-bold">Fornavn</div>
                        <v-form v-model="validated" lazy-validation>
                            <p class="pt-2" v-if="!edit">{{modifiedUser.firstName}}</p>
                            <v-text-field
                                v-else
                                class="profile__container--content__input"
                                v-model="modifiedUser.firstName"
                                required
                                :rules="[rules.required, rules.name, rules.containsCharacter]"
                                color="#579FA7"
                                dense
                            ></v-text-field>
                        </v-form>
                    </div>

                    <div class="py-2">
                        <div class="font-weight-bold">Etternavn</div>
                        <v-form v-model="validated" lazy-validation>
                            <p class="pt-2" v-if="!edit">{{modifiedUser.lastName}}</p>
                            <v-text-field
                                v-else
                                v-model="modifiedUser.lastName"
                                class="profile__container--content__input"
                                required
                                :rules="[rules.required, rules.name, rules.containsCharacter]"
                                color="#579FA7"
                                dense
                            ></v-text-field>
                        </v-form>
                    </div>

                    <div class="py-2">
                        <div class="font-weight-bold">E-post</div>
                        <v-form v-model="validated" lazy-validation ref="eChangeVal">
                            <p class="pt-2" v-if="!edit">{{modifiedUser.email}}</p>
                            <v-text-field
                                v-else
                                v-model="modifiedUser.email"
                                class="profile__container--content__input"
                                :class="emailError ? 'profile__container--content__input-error' : 'profile__container--content__input-info'"
                                required
                                :hint="showEmailMessage ? 'For å kunne endre sender vi en engangskode for bekreftelse. Dersom du endrer e-postadressen din, vil alle eksisterende tilkoblinger til Apple og/eller Google-kontoer bli fjernet.' : ''"
                                persistent-hint
                                @input="emailError = false"
                                :rules="[rules.required, rules.email, rules.changeEmailError]"
                                color="#579FA7"
                                dense
                                @focus="showEmailMessage = true"
                                @blur="showEmailMessage = false"
                            ></v-text-field>
                        </v-form>
                    </div>
                    
                    <div class="py-2">
                        <div class="font-weight-bold">Mobilnummer</div>
                        <v-form v-model="validated" lazy-validation ref="mChangeVal">
                            <p class="pt-2" v-if="!edit">{{modifiedUser.mobileNumber}}</p>
                            <v-text-field
                                v-else
                                v-model="modifiedUser.mobileNumber"
                                class="profile__container--content__input"
                                :class="mobileError ? 'profile__container--content__input-error' : 'profile__container--content__input-info'"
                                required
                                :hint="showMobileMessage ? 'For å kunne endre sender vi en engangskode for bekreftelse. Dersom du endrer mobilnummeret ditt, vil eventuelle tilkoblinger til Vipps bli fjernet.' : ''"
                                persistent-hint
                                @input="mobileError = false"
                                :rules="[rules.required, rules.mobile, rules.changeMobileError]"
                                color="#579FA7"
                                dense
                                @focus="showMobileMessage = true"
                                @blur="showMobileMessage = false"
                            ></v-text-field>
                        </v-form>
                    </div>

                    <div class="py-2">
                        <div class="font-weight-bold">Telefon arbeid (valgfri)</div>
                        <v-form v-model="validated" lazy-validation>
                            <p class="pt-2" v-if="!edit">{{modifiedUser.phoneNoWork}} <span v-if="!modifiedUser.phoneNoWork" class="text--disabled">Ikke oppgitt</span></p>
                            <v-text-field
                                v-else
                                v-model="modifiedUser.phoneNoWork"
                                class="profile__container--content__input"
                                :rules="[rules.optionalPhone]"
                                color="#579FA7"
                                dense
                            ></v-text-field>
                        </v-form>
                    </div>
                    <div class="py-2">
                        <div class="font-weight-bold">Hjemmetelefon (valgfri)</div>
                        <v-form v-model="validated" lazy-validation>
                        <p class="pt-2" v-if="!edit">{{modifiedUser.phoneNoHome}} <span v-if="!modifiedUser.phoneNoHome" class="text--disabled">Ikke oppgitt</span></p>
                            <v-text-field
                                v-else
                                v-model="modifiedUser.phoneNoHome"
                                class="profile__container--content__input"
                                :rules="[rules.optionalPhone]"
                                color="#579FA7"
                                dense
                            ></v-text-field>
                        </v-form>
                    </div>
                    <div v-if="$vuetify.breakpoint.lgAndUp">
                        <v-btn
                            class="text-none mt-8"
                            rounded
                            text
                            color="primary"
                            @click="sendGdprSms()"
                        >
                            <div class="font-weight-bold">Vis mine lagrede data</div>
                            <v-icon class="pl-2">fxt-lock</v-icon>
                        </v-btn>
                        <div v-if="layout == 'portal'">
                            <v-btn
                                class="font-weight-bold secondary-font text-none mt-2"
                                color="#EA412A"
                                rounded
                                text
                                @click="showDialog = !showDialog"
                            >
                                <div class="subtitle-1">Slett min bruker</div>
                                <v-icon class="pl-2" size="18">fxt-trash-alt</v-icon>
                            </v-btn>
                            <common-dialog 
                                v-if="showDialog" 
                                :show="showDialog" 
                                :title="`Vil du virkelig slette din bruker?`" 
                                icon="fxt-warning"
                                buttonTextCancel="Nei, avbryt"
                                buttonTextConfirm="Ja, slett meg!"
                                buttonIconConfirm="fxt-trash-alt"
                                buttonColorConfirm="#EA412A"
                                @closeDialog="showDialog = false"
                                @confirmAction="deleteOnlineSluttKunde()"
                                :layout="layout"
                            >
                                <p>Du er i ferd med å slette brukerprofilen din på Fixit.no. Vi gjør oppmerksom på at dette ikke vil slette registrerte personopplysninger hos salonger du har bestilt time hos på Fixit.no, for å gjøre det må du kontakte salongene direkte. Ved sletting av din Fixit.no-brukerprofil vil du ikke lengre kunne bestille time på Fixit.no, i Fixit-appen eller på salongenes hjemmesider.</p>
                                <p>Vil du slette brukerprofilen din fordi du får markedsføringshenvendelser fra Fixit.no? Et alternativ til sletting er å deaktivere samtykkene til å motta slike henvendelse på siden 'Personvern og samtykker'.</p>
                                <p class="font-weight-bold">Vil du fortsatt gjennomføre sletting av brukerprofilen din? I så fall trykk på "Ja, slett meg!" knappen.</p>
                            </common-dialog>
                        </div>
                        <common-dialog 
                            v-if="showGdprDialog" 
                            :show="showGdprDialog" 
                            :title="`Vis mine lagrede data`" 
                            icon="fxt-lock"
                            buttonTextCancel="Avbryt"
                            buttonTextConfirm="Se min informasjon"
                            buttonIconConfirm="fxt-external-link"
                            buttonColorConfirm="#472449"
                            @closeDialog="showGdprDialog = false"
                            @confirmAction="redirectToGdpr()"
                            :layout="layout"
                        >
                            <p>Vi har sendt deg en SMS med et passord for å logge inn. Klikk på “se min informasjon” for å gå videre.</p>

                        </common-dialog>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                    <div class="py-2">
                        <div class="font-weight-bold">Adresse</div>
                        <v-form v-model="validated" lazy-validation>
                            <p class="pt-2" v-if="!edit">{{modifiedUser.address}} <span v-if="!modifiedUser.address" class="text--disabled">Ikke oppgitt</span></p>
                            <v-text-field
                                v-else
                                v-model="modifiedUser.address"
                                class="profile__container--content__input"
                                :rules="[rules.containsCharacter]"
                                color="#579FA7"
                                dense
                            ></v-text-field>
                        </v-form>
                    </div>
                    <div class="d-flex">
                        <div class="py-2 pr-16">
                            <div class="font-weight-bold">Postnr</div>
                            <v-form v-model="validated" lazy-validation>
                                <p class="pt-2" v-if="!edit">{{modifiedUser.postalCode}} <span v-if="!modifiedUser.postalCode" class="text--disabled">Ikke oppgitt</span></p>
                                <v-text-field
                                    v-else
                                    v-model="modifiedPostalCode"
                                    class="profile__container--content__input"
                                    :rules="invalidPostalCode || modifiedPostalCode.length < 4 ? [rules.postalCode, rules.containsCharacter] : [rules.containsCharacter]"
                                    color="#579FA7"
                                    dense
                                ></v-text-field>
                            </v-form>
                        </div>
                        <div class="py-2">
                            <div class="font-weight-bold">Sted</div>
                            <v-form v-model="validated" lazy-validation>
                                <p class="pt-2" v-if="!edit">{{modifiedUser.postalArea}} <span v-if="!modifiedUser.postalArea" class="text--disabled">Ikke oppgitt</span></p>
                                <v-text-field
                                    v-else
                                    v-model="modifiedUser.postalArea"
                                    class="profile__container--content__input"
                                    color="#579FA7"
                                    readonly
                                    dense
                                ></v-text-field>
                            </v-form>
                        </div>
                    </div>
                    <div class="py-2">
                        <div class="font-weight-bold pb-2">Kjønn</div>
                        <v-radio-group v-if="edit" v-model="modifiedUser.gender" row class="mt-0">
                            <v-radio
                                label="Kvinne"
                                :value="0"
                                :style="!edit ? 'color: var(--v-primary-base)' : ''"
                                on-icon="fxt-radio-on"
                                off-icon="fxt-radio-off"
                            ></v-radio>
                            <v-radio
                                label="Mann"
                                :value="1"
                                :style="!edit ? 'color: var(--v-primary-base)' : ''"
                                on-icon="fxt-radio-on"
                                off-icon="fxt-radio-off"
                            ></v-radio>
                            <v-radio
                                label="Ikke valgt"
                                :value="null"
                                :style="!edit ? 'color: var(--v-primary-base)' : ''"
                                on-icon="fxt-radio-on"
                                off-icon="fxt-radio-off"
                            ></v-radio>
                        </v-radio-group>
                        <div v-else>
                            <p>{{gender(modifiedUser.gender)}}</p>
                        </div>
                    </div>
                    <div v-if="$vuetify.breakpoint.mdAndDown">
                        <v-btn
                            class="text-none mt-8"
                            rounded
                            text
                            color="primary"
                            @click="sendGdprSms()"
                        >
                            <div class="font-weight-bold">Vis mine lagrede data</div>
                            <v-icon class="pl-2">fxt-lock</v-icon>
                        </v-btn>
                        <div v-if="layout == 'portal'">
                            <v-btn
                                class="font-weight-bold secondary-font text-none mt-2"
                                color="#EA412A"
                                rounded
                                text
                                @click="showDialog = !showDialog"
                            >
                                <div class="subtitle-1">Slett min bruker</div>
                                <v-icon class="pl-2" size="18">fxt-trash-alt</v-icon>
                            </v-btn>
                            <common-dialog 
                                v-if="showDialog" 
                                :show="showDialog" 
                                :title="`Vil du virkelig slette din bruker?`" 
                                icon="fxt-warning"
                                buttonTextCancel="Nei, avbryt"
                                buttonTextConfirm="Ja, slett meg!"
                                buttonIconConfirm="fxt-trash-alt"
                                buttonColorConfirm="#EA412A"
                                @closeDialog="showDialog = false"
                                @confirmAction="deleteOnlineSluttKunde()"
                                :layout="layout"
                            >
                                <p>Du er i ferd med å slette brukerprofilen din på Fixit.no. Vi gjør oppmerksom på at dette ikke vil slette registrerte personopplysninger hos salonger du har bestilt time hos på Fixit.no, for å gjøre det må du kontakte salongene direkte. Ved sletting av din Fixit.no-brukerprofil vil du ikke lengre kunne bestille time på Fixit.no, i Fixit-appen eller på salongenes hjemmesider.</p>
                                <p>Vil du slette brukerprofilen din fordi du får markedsføringshenvendelser fra Fixit.no? Et alternativ til sletting er å deaktivere samtykkene til å motta slike henvendelse på siden 'Personvern og samtykker'.</p>
                                <p class="font-weight-bold">Vil du fortsatt gjennomføre sletting av brukerprofilen din? I så fall trykk på "Ja, slett meg!" knappen.</p>
                            </common-dialog>
                        </div>
                        <common-dialog 
                            v-if="showGdprDialog" 
                            :show="showGdprDialog" 
                            :title="`Vis mine lagrede data`" 
                            icon="fxt-lock"
                            buttonTextCancel="Avbryt"
                            buttonTextConfirm="Se min informasjon"
                            buttonIconConfirm="fxt-external-link"
                            buttonColorConfirm="#472449"
                            @closeDialog="showGdprDialog = false"
                            @confirmAction="redirectToGdpr()"
                            :layout="layout"
                        >
                            <p>Vi har sendt deg en SMS med et passord for å logge inn. Klikk på “se min informasjon” for å gå videre.</p>

                        </common-dialog>
                    </div>
                </v-col>
            </v-row>
        </div>
        <v-dialog v-model="showOTCdialog"
            :content-class="layout == 'portal' ? 'login-dialog fixit-background-gradient' : 'login-dialog chain-background-white'"
            class="dialog-width" max-width="768" height="600" :fullscreen="$vuetify.breakpoint.smAndDown" persistent
            no-click-animation
            @click:outside="closeOTCDialog()">


            <v-card class="login-dialog--login__content" :class="layout == 'portal' ? 'fixit-background-gradient' : ''" flat
                :style="!$vuetify.breakpoint.smAndDown ? 'height: 600px' : ''">
                <v-app-bar flat color="rgba(0, 0, 0, 0)">
                    <v-spacer></v-spacer>
                    <v-btn color="#472449" icon @click="closeOTCDialog()">
                        <v-icon size="30">fxt-close</v-icon>
                    </v-btn>
                </v-app-bar>
                <div class="login-dialog--login__content-container">
                    <transition mode="out-in" name="scroll-x-transition">
                        
                        <!-- Change email and mobile flow -->
                        <the-code key="verify-email" v-if="[state.EMAILCODE].includes(currentForm)" 
                            title="Er dette deg?"
                            :description="'Bekreft ved å taste engangskoden som du har mottatt fra oss på '" 
                            :error="error" 
                            :showResendText="showResendText"
                            :layout="layout"
                            :email="modifiedUser.email" 
                            @changed="resetError()"
                            @setValue="setCode"
                            @verify="VerifyStep()">
                        </the-code>

                        <the-code key="verify-sms" v-if="[state.SMSCODE].includes(currentForm)" 
                            title="Engangskode"
                            description="Skriv inn engangskoden som du har mottatt på SMS." 
                            :error="error" 
                            :showResendText="showResendText"
                            :layout="layout"
                            @setValue="setCode" 
                            @changed="resetError()"
                            @verify="VerifyStep()">
                        </the-code>


                        <!-- Change password flow -->
                        <change-password-step key="reset-password" title="Endre passord" ref="changePass"
                            v-if="[passwordStates.RESET_PASSWORD].includes(currentChangePasswordForm)" 
                            description="Passord må være minimum 8 tegn og med minst ett tall og én stor bokstav."
                            :layout="layout"
                            :error="error"
                            @setValue="setPassword"
                            @setOldPassword="setOldPassword"
                            @setNewPassword="setNewPassword"
                            @verify="verifyChangePasswordStep()">
                        </change-password-step>

                        <the-code key="verify-email" v-if="[passwordStates.VERIFY_EMAIL].includes(currentChangePasswordForm)" 
                            title="Er dette deg?"
                            :description="'Bekreft ved å taste engangskoden som du har mottatt fra oss på '" 
                            :error="error" 
                            :showResendText="showResendText"
                            :layout="layout"
                            :email="user.email" 
                            @changed="resetError()"
                            @setValue="setCode"
                            @verify="verifyChangePasswordStep()">
                        </the-code>

                        <the-password key="create-password" title="Lag et passord" ref="validation"
                            v-if="[passwordStates.NEW_PASSWORD].includes(currentChangePasswordForm)" 
                            description="Passordet må inneholde minimum 8 tegn, minst ett tall og én stor bokstav."
                            :layout="layout" 
                            @setValue="setPassword"
                            @verify="verifyChangePasswordStep()">
                        </the-password>
                
                    </transition>
                    <div class="login-dialog--login__content-container--options"
                        :class="!$vuetify.breakpoint.smAndDown ? 'login-dialog--login__content-container--options_limited' : ''">
                        <v-btn v-if="[passwordStates.RESET_PASSWORD, passwordStates.NEW_PASSWORD].includes(currentChangePasswordForm)" :disabled="verifyInputFields()" elevation="0" block color="var(--v-primary-base)" dark rounded
                            :class="!$vuetify.breakpoint.smAndDown ? 'my-3' : ''" @click="verifyChangePasswordStep()">
                            Fortsett
                        </v-btn>
                        <transition mode="out-in" name="scroll-y-reverse-transition">
                            <v-btn v-if="[passwordStates.VERIFY_EMAIL].includes(currentChangePasswordForm) || [state.EMAILCODE, state.SMSCODE].includes(currentForm)" block color="var(--v-primary-base)"
                                dark text rounded :class="!$vuetify.breakpoint.smAndDown ? 'my-3' : ''" @click="resendCode()">
                                Send kode på nytt
                            </v-btn>
                        </transition>
                        <transition mode="out-in" name="scroll-y-reverse-transition">
                            <v-btn elevation="0" block color="var(--v-primary-base)" v-if="[passwordStates.RESET_PASSWORD].includes(currentChangePasswordForm)" dark text
                                rounded class="mt-3" @click="resetPassword()">
                                Glemt passord?
                            </v-btn>
                        </transition>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { CommonDialog, ProfileDropdown, TitleAndEdit } from '../../../Common/CommonComponents'
import AppSvc from '../../../../services/app-svc'
import ProfileSvc from '../../../../services/profile-svc';
import { TheCode, ThePassword } from '../../../Common/CommonSteps'
import ChangePasswordStep from './components/ChangePasswordStep.vue'

let profileSvc = null;
let service = null;

import User from '../../../../models/User';

export default {
    components: { CommonDialog, ProfileDropdown, TitleAndEdit, TheCode, ThePassword, ChangePasswordStep },
    props: {
        user: {
            required: true,
            default: null,
            type: Object
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
    },
    data() {
        return {
            showDialog: false,
            showGdprDialog: false,
            gdprRedirectUrl: '',
            edit: false,
            hasChanged: false,
            modifiedUser: {...this.user},
            validated: false,
            rules: {
                required: value => !!value || 'Dette feltet er obligatorisk.',
                containsCharacter: value => value.replace(/\s/g, '').length || 'Må inneholde tegn',
                name: value => {
                    const pattern = /^[a-zA-Z\Wæøå]*$/
                    return pattern.test(value) || 'Navn kan ikke inneholde tall eller spesialtegn.'
                },
                mobile: value => {
                    const pattern = /^[0-9]{8}$/
                    return pattern.test(value) || 'Mobilnummer må være 8 siffer.'
                },
                optionalPhone: value => {
                    const pattern = /^[0-9]{8}$/
                    return (pattern.test(value) || value.length == 0) || 'Telefonnummer må være 8 siffer.'
                },
                postalCode: value => {
                    const pattern = /^[0-9]{4}$/

                    return (pattern.test(value) || value.length == 0 || this.invalidPostalCode) || this.invalidPostalCode ? 'Ugyldig postnummer' : 'Postnummer må være 4 siffer.'
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    const unspportedDomains = ['yourwish.no']
                    const illegalDomain = unspportedDomains.includes(value.split('@')[1])
                    return pattern.test(value) && !illegalDomain || (illegalDomain ? 'Dette domenet kan ikke brukes.' : 'Ugyldig e-postaddresse.')
                },
                changeEmailError: () => {
                    return !this.emailError || 'Denne e-post addressen er allerede i bruk.'
                },
                changeMobileError: () => {
                    return !this.mobileError || 'Dette mobilnummeret er allerede i bruk.'
                }
            },

            showOTCdialog: false,
            showResendText:false,
            state: {
                EMAILCODE: 'verify-email',
                SMSCODE: 'verify-sms'
            },
            passwordStates: {
                RESET_PASSWORD: 'reset-password',
                FORGOT_PASSWORD: 'forgot-password',
                VERIFY_EMAIL: 'password-verify-email',
                NEW_PASSWORD: 'new-password'
            },

            showMobileMessage: false,
            showEmailMessage: false,
            mobileError: false,
            emailError: false,
            currentForm: '',
            requiredActions: [],
            code: '',
            error: '',
            loading: false,

            clientIdentity: null,
            emailTicket: null,
            mobileTicket: null,

            modifiedPostalCode: this.user.postalCode,
            invalidPostalCode: false,

            currentChangePasswordForm: '',
            oldPassword: '',
            newPassword: '',
        }
    },
    computed: {
        isTpn() {
			return !!this.tpnChainId
		},
		tpnChainId() {
            /**
             * Webshop TPN or Homepages TPN
             */
            return this.layout == 'portal' ? window.location.pathname.includes('nettbutikk') ? chainIdFromWebshopUrl : 0 : this.$store.getters['cmsConfigHomepage/getChainId'];
		},
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        chainIdFromWebshopUrl() {
            /**
             * TEMP: Find a better solution.
             * 
             * ChainId always comes after nettbutikk/. Split at nettbutikk/ and return the chainId
             */
            var path = window.location.pathname
            return parseInt(path.slice(path.indexOf('nettbutikk/') + 11).split('/')[0])
        }
	},
    methods: {
        async verifyChangePasswordStep() {
            this.loading = true;
            this.error = ''

            var params = {
                code: this.code,
                // ...(trueCondition && { dogs: "woof" }),
                oldPassword: this.oldPassword,
                password: this.newPassword,
                clientIdentity: this.clientIdentity,
                step: this.currentChangePasswordForm === 'password-verify-email' ? 'verify-email' : this.currentChangePasswordForm
            };

            const res = await service.ChangePassword(process.env.VUE_APP_FIXIT_CORE_API_URL, params);
            if (res.data.responseCode === 200) {
                this.clientIdentity = res.data.clientIdentity
                if (res.data.nextStep) {
                    this.showOTCdialog = true
                    this.currentChangePasswordForm = res.data.nextStep === 'verify-email' ? 'password-verify-email' : res.data.nextStep
                } else {
                    if (res.data.responseCode === 200) {
                        this.showOTCdialog = false
                        this.$forceUpdate();
                        this.toggleEdit();
                        this.$emit('updateUser', new User(res.data.fixitNoUser))
                    }
                }
            } else {
                this.error = res.data.responseMessage
            }
            
            
			this.loading = false;
        },
        async validatePostalCode(){
            const res = await profileSvc.ValidatePostalCode(this.bookingApi, this.modifiedPostalCode);
            if(res.postalCodes.length > 0) {
                this.invalidPostalCode = false
                this.modifiedUser.postalCode = res.postalCodes[0].postalCode;
                this.modifiedUser.postalArea = res.postalCodes[0].city;
            } else {
                this.invalidPostalCode = true
            }
        },
        async updateProfile() {
			this.loading = true;
			this.modifiedUser.profileCreatedTime = this.$moment(this.modifiedUser.profileCreatedTime).format('YYYY-MM-DD');
			this.modifiedUser.profileUpdatedTime = this.$moment(this.modifiedUser.profileUpdatedTime).format('YYYY-MM-DD');
			var user = new User(this.modifiedUser);
			user.mobileNumber = this.modifiedUser.mobileNumber;
			user.userId = this.modifiedUser.userId;
			user.birthDate = this.modifiedUser.birthDate ? this.$moment(this.modifiedUser.birthDate).format('YYYY-MM-DD') : null;
			var params = {
				fixitNoUser: user,
				emailTicket: this.emailTicket,
				mobileTicket: this.mobileTicket,
				clientIdentity: this.clientIdentity
			};
			const userRes = await service.UpdateProfile(process.env.VUE_APP_FIXIT_CORE_API_URL, params);
            /**
             * Response code is only set to 200 once all potential steps have been completed. If 
             * the user has to validate phone number or email, responsecode won't be 200 until this 
             * has been completed.
             */
            if (userRes && userRes.data.responseCode == 200) {
                this.$forceUpdate();
                this.toggleEdit();
                this.$emit('updateUser', new User(userRes.data.fixitNoUser))
            }
            if (userRes.data.validationStatus === 0) {
                if (userRes.data.responseCode === 412) {
                    this.requiredActions = userRes.data.requiredActions
                    this.currentForm = this.requiredActions[0]
                    this.clientIdentity = userRes.data.clientIdentity
                    this.showOTCdialog = true
                }
            }
            
            if (userRes.data.responseCode == 500 && userRes.data.requiredActions && userRes.data.requiredActions.length == 0) {
                this.validationStatusMessage(userRes.data.validationStatus)
            }
            
			this.loading = false;
		},
        async deleteOnlineSluttKunde() {
            if (await profileSvc.DeleteUser(process.env.VUE_APP_FIXIT_NO_BOOKING_URL)) {
                profileSvc.emitSnackbar({
                    message: `Din bruker har blitt slettet! Du blir logget ut om 5 sekunder.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'info'
                })
                setTimeout( () => this.$emit('logout'), 5000);
            } else {
                profileSvc.emitSnackbar({
                    message: `Noe gikk galt når vi prøvde å slette din bruker!`, 
                    visible: true, 
                    duration: 3000, 
                    state: 'error'
                })
            }
        },
        gender(gender) {
            switch(gender) {
                case 0: return 'Kvinne'
                case 1: return 'Mann'
                default: return 'Ikke valgt'
            }
        },
        verifyInputFields() {
            const pattern = /^(?=.*\d)(?=.*[A-Z])[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/
            switch (this.currentChangePasswordForm) {
                case 'reset-password':
                    return !pattern.test(this.newPassword)
                case 'new-password':
                    return !pattern.test(this.newPassword)
                default:
                    return false
            }
        },
        toggleEdit() {
            this.edit = !this.edit
        },
        resetPassword() {
            this.currentChangePasswordForm = 'forgot-password'
            this.verifyChangePasswordStep()
        },
        setPassword(value) {
            this.newPassword = value
        },
        setOldPassword(value) {
            this.oldPassword = value
        },
        setNewPassword(value) {
            this.newPassword = value
        },
        setCode(value) {
            this.code = value
        },
        resetError() {
            this.error = ''
        },
        validationStatusMessage(validationStatus) {
            switch (validationStatus) {
                case 0: break;
                case 1: 
                    this.emailError = true; 
                    this.$refs.eChangeVal.validate()
                    break;
                case 2: 
                    this.mobileError = true; 
                    this.$refs.mChangeVal.validate()
                    break;
                case 3: 
                    this.emailError = true; 
                    this.mobileError = true; 
                    this.$refs.eChangeVal.validate()
                    this.$refs.mChangeVal.validate()
                    break;
            }
        },


        VerifyStep() {
            var body = {
                code: this.code,
                clientIdentity: this.clientIdentity
            }

            if (this.currentForm === 'verify-email') {
                Object.assign(body, { email: this.modifiedUser.email })

                service.VerifyNewEmail(process.env.VUE_APP_FIXIT_CORE_API_URL, body).then(response => {
                    this.error = ''
                    if (response.data.responseCode === 200) {
                        this.emailTicket = response.data.dto
                        this.requiredActions = this.requiredActions.filter(x =>  x !== 'verify-email' )
                        if (this.requiredActions.length != 0) {
                            this.currentForm = this.requiredActions[0]
                        } else {
                            this.showOTCdialog = false
                            this.updateProfile()
                        }
                    } else {
                        this.showResendText = false
                        this.error = response.data.responseMessage
                    }
                })
            }
            if (this.currentForm === 'verify-sms') {
                Object.assign(body, { mobile: this.modifiedUser.mobileNumber })

                service.VerifyNewMobileNumber(process.env.VUE_APP_FIXIT_CORE_API_URL, body).then(response => {
                    this.error = ''
                    if (response.data.responseCode === 200) {
                        this.mobileTicket = response.data.dto
                        this.requiredActions = this.requiredActions.filter(x =>  x !== 'verify-sms')
                        if (this.requiredActions.length != 0) {
                            this.currentForm = this.requiredActions[0]
                        } else {
                            this.showOTCdialog = false
                            this.updateProfile()
                        }
                    } else {
                        this.showResendText = false
                        this.error = response.data.responseMessage
                    }
                })
            }
        },

        async resendCode() {
            this.modifiedUser.profileCreatedTime = this.$moment(this.modifiedUser.profileCreatedTime).format('YYYY-MM-DD');
			this.modifiedUser.profileUpdatedTime = this.$moment(this.modifiedUser.profileUpdatedTime).format('YYYY-MM-DD');
			var user = new User(this.modifiedUser);
			user.mobileNumber = this.modifiedUser.mobileNumber;
			user.userId = this.modifiedUser.userId;
			user.birthDate = this.modifiedUser.birthDate ? this.$moment(this.modifiedUser.birthDate).format('YYYY-MM-DD') : null;
			var params = {
				fixitNoUser: user,
				emailTicket: this.emailTicket,
				mobileTicket: this.mobileTicket,
				clientIdentity: this.clientIdentity,
                resendCode: this.currentForm == 'verify-sms' ? 'sms' : 'email'
			};
            /**
             * Passing resendCode query to update profile triggers a new code to be sent to the user
             */
			const userRes = await service.UpdateProfile(process.env.VUE_APP_FIXIT_CORE_API_URL, params);
            this.error = ''
            this.showResendText = true
        },
        clearStates() {
            if (this.currentChangePasswordForm == 'reset-password') {
                this.$refs.changePass.clearStates()
            }
            this.showResendText = false
            this.showMobileMessage = false
            this.showEmailMessage = false
            this.mobileError = false
            this.emailError = false
            this.currentForm = ''
            this.requiredActions = []
            this.code = ''
            this.error = ''
            this.loading = false
            this.clientIdentity = null
            this.emailTicket = null
            this.mobileTicket = null
            this.currentChangePasswordForm = ''
            this.oldPassword = ''
            this.newPassword = ''
        },
        closeOTCDialog() {
            this.showOTCdialog = false
            this.clearStates()
        },
        async sendGdprSms() {
            this.showGdprDialog = true
            const res = await profileSvc.GetGdprUser(this.bookingApi, {isTpn: this.isTpn ? 'True' : 'False', tpnChainId: this.tpnChainId.toString()});
            if (res) {
                this.gdprRedirectUrl = res.data.gdprUrl
            }
        },
        redirectToGdpr() {
            window.open(this.gdprRedirectUrl, '_blank')
        }
    },
    watch: {
        modifiedUser: {
            handler: {
                deep: true,
                handler(val) {
                    // Compare the original user data to the changed value to determine wether it's been altered.
                    JSON.stringify(this.user) === JSON.stringify(val) ? this.hasChanged = false : this.hasChanged = true;
                }
            },
        },
        modifiedPostalCode: {
            handler: {
                deep: true,
                handler(val) {
                    if(val.length == 4 && val.replace(/\s/g, '').length){
                        this.validatePostalCode();
                    }
                } 
            }
        }
    },
    async created() {
		service = await AppSvc(this.$axios);
        profileSvc = await ProfileSvc(this.$axios);
	},
    beforeDestroy() {
		service = null
        profileSvc = null
	}
}
</script>